import useAPI from '@/hooks/useAPI';
import AppointmentsRepository, {
  GetBookingParamsParams
} from '@/repositories/AppointmentsRepository';

export const useBookingParams = (
  params: GetBookingParamsParams,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const appointmentsRepository = AppointmentsRepository();

  return useAPI({
    queryKey: ['getBookingParams', params],
    queryFn: async () => {
      const data = await appointmentsRepository.getBookingParams(params);
      return { data, isError: false };
    },
    enabled
  });
};

export default useBookingParams;
